<ng-container *ngIf="isError">
  {{ errorMessage}}
</ng-container>


<ng-container *ngIf="productLogoUrl">
  <div style="margin: 10px auto;text-align: center;">
    <img height="80" class="card-img" [src]="productLogoUrl" />
  </div>
</ng-container>

<mat-card class="step-card">
  <mat-card-header>
    <mat-card-title>{{"ORDER.SUMMARY.TITLE" | translate}}</mat-card-title>
    <mat-card-subtitle></mat-card-subtitle>
  </mat-card-header>
  <mat-card-content>

    <ng-container *ngIf="order">
      <app-order-summary [product]="product" [orderForm]="order"></app-order-summary>
    </ng-container>


  </mat-card-content>
</mat-card>


